/**
 * Product Map — infinite pan/scroll grid.
 *
 * Desktop: the canvas is a 3x3 tiling of the base 18-slot (2 rows x 9 cols)
 * block. When the user pans past one block's width/height, we silently snap
 * the offset back by exactly one block so it loops forever.
 *
 * Mobile: a simpler vertical-only infinite scroll. The canvas is 3 vertical
 * copies of a 9-row x 2-col block; when native scrolling nears the top or
 * bottom third, we jump the scroll position by exactly one block's height
 * (instant, imperceptible, since the content tiles identically).
 *
 * Both blocks are always in the DOM; CSS shows only one at a time per
 * breakpoint, so only the visible one is ever actually interactive.
 */
(function () {
  // ---- Desktop: drag + wheel panning ----
  document.querySelectorAll('[data-product-map] .product-map__desktop').forEach(function (desktopRoot) {
    var viewport = desktopRoot.querySelector('[data-map-viewport]');
    var canvas = desktopRoot.querySelector('[data-map-canvas]');
    if (!viewport || !canvas) return;

    var root = desktopRoot.closest('[data-product-map]');
    var styles = getComputedStyle(root);
    var cellW = parseFloat(styles.getPropertyValue('--cell-w')) || 320;
    var cellH = parseFloat(styles.getPropertyValue('--cell-h')) || 400;
    var gap = parseFloat(styles.getPropertyValue('--map-gap')) || 12;

    // 3 tiles across, 5 tiles down — vertical needs more copies since a
    // block is only 2 rows tall, and tall viewports need enough buffer
    // below the wrap point to never run out of tiled content on screen.
    var TILES_X = 3;
    var TILES_Y = 5;

    var blockW = (cellW + gap) * 9;
    var blockH = (cellH + gap) * 2;

    var x = -Math.floor(TILES_X / 2) * blockW;
    var y = -Math.floor(TILES_Y / 2) * blockH;

    var isDragging = false;
    var startX = 0;
    var startY = 0;
    var originX = 0;
    var originY = 0;
    var dragged = false;

    function apply() {
      canvas.style.transform = 'translate3d(' + x + 'px, ' + y + 'px, 0)';
    }

    function wrap() {
      while (x > 0) x -= blockW;
      while (x < -(TILES_X - 1) * blockW) x += blockW;
      while (y > 0) y -= blockH;
      while (y < -(TILES_Y - 1) * blockH) y += blockH;
    }

    function pointerDown(e) {
      isDragging = true;
      dragged = false;
      viewport.classList.add('is-dragging');
      var point = e.touches ? e.touches[0] : e;
      startX = point.clientX;
      startY = point.clientY;
      originX = x;
      originY = y;
    }

    function pointerMove(e) {
      if (!isDragging) return;
      var point = e.touches ? e.touches[0] : e;
      var dx = point.clientX - startX;
      var dy = point.clientY - startY;
      if (Math.abs(dx) > 4 || Math.abs(dy) > 4) dragged = true;
      x = originX + dx;
      y = originY + dy;
      wrap();
      apply();
      e.preventDefault();
    }

    function pointerUp() {
      isDragging = false;
      viewport.classList.remove('is-dragging');
    }

    canvas.addEventListener(
      'click',
      function (e) {
        if (dragged) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );

    canvas.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    viewport.addEventListener('mousedown', pointerDown);
    window.addEventListener('mousemove', pointerMove);
    window.addEventListener('mouseup', pointerUp);

    viewport.addEventListener('touchstart', pointerDown, { passive: true });
    window.addEventListener('touchmove', pointerMove, { passive: false });
    window.addEventListener('touchend', pointerUp);

    viewport.addEventListener(
      'wheel',
      function (e) {
        e.preventDefault();
        x -= e.deltaX;
        y -= e.deltaY;
        wrap();
        apply();
      },
      { passive: false }
    );

    apply();
  });

  // ---- Mobile: vertical-only infinite scroll ----
  document.querySelectorAll('[data-mobile-scroll]').forEach(function (scrollEl) {
    var canvas = scrollEl.querySelector('[data-mobile-canvas]');
    if (!canvas) return;

    function init() {
      var blockHeight = canvas.scrollHeight / 3;
      if (!blockHeight) return;
      scrollEl.scrollTop = blockHeight;

      scrollEl.addEventListener('scroll', function () {
        if (scrollEl.scrollTop < blockHeight * 0.5) {
          scrollEl.scrollTop += blockHeight;
        } else if (scrollEl.scrollTop > blockHeight * 1.5) {
          scrollEl.scrollTop -= blockHeight;
        }
      });
    }

    // Images load async and change scrollHeight, so measure after paint.
    requestAnimationFrame(function () {
      requestAnimationFrame(init);
    });
  });
})();


